import { render, staticRenderFns } from "./task-status.vue?vue&type=template&id=650f1140&scoped=true"
import script from "./task-status.vue?vue&type=script&lang=js"
export * from "./task-status.vue?vue&type=script&lang=js"
import style0 from "./task-status.vue?vue&type=style&index=0&id=650f1140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f1140",
  null
  
)

export default component.exports